import request from '@/utils/request'
// 配送方式列表
export function fetchExpresses(params) {
  return request({
    url: '/expresses',
    method: 'get',
    params: params
  })
}

// 安装/卸载配送方式
export function postExpresses(params) {
  return request({
    url: '/expresses',
    method: 'post',
    params: params,

  })
}

// 查询商家所有的快递
export function allExpresses(params) {
  return request({
    url: '/expresses/business',
    method: 'get',
    params: params
  })
}

// 快递鸟账号配置
export function kuaidn(data) {
  return request({
    url: '/expresses/kuaidn',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/expresses.js